import type React from "react";
import { ReactComponent as MeasurementStart14 } from "./14/measurement-start.svg";
import { ReactComponent as MeasurementCursor28 } from "./28/measurement-cursor.svg";
import { ReactComponent as ThreeDObject16 } from "./16/3d-object.svg";
import { ReactComponent as Add16 } from "./16/add.svg";
import { ReactComponent as BoxDimensions16 } from "./16/box-dimensions.svg";
import { ReactComponent as Check16 } from "./16/check.svg";
import { ReactComponent as Linear16 } from "./16/linear.svg";
import { ReactComponent as Close16 } from "./16/close.svg";
import { ReactComponent as Fold16 } from "./16/fold.svg";
import { ReactComponent as Info16 } from "./16/info.svg";
import { ReactComponent as Question16 } from "./16/question.svg";
import { ReactComponent as NaviLeftArrow24 } from "./24/navi-left-arrow.svg";
import { ReactComponent as LeftArrow16 } from "./16/left-arrow.svg";
import { ReactComponent as Lock16 } from "./16/lock.svg";
import { ReactComponent as ToolbarMove28 } from "./28/move.svg";
import { ReactComponent as ToolbarMeasure28 } from "./28/measure.svg";
import { ReactComponent as ToolbarRotation24 } from "./24/toolbar-rotation.svg";
import { ReactComponent as CheckboxEmpty24 } from "./24/checkbox-empty.svg";
import { ReactComponent as CheckboxSolid24 } from "./24/checkbox-solid.svg";
import { ReactComponent as Reset24 } from "./24/reset.svg";
import { ReactComponent as Search24 } from "./24/search.svg";
import { ReactComponent as Search16 } from "./16/search.svg";
import { ReactComponent as Close24 } from "./24/close.svg";
import { ReactComponent as Add24 } from "./24/add.svg";
import { ReactComponent as CompleteSolid24 } from "./24/complete-solid.svg";
import { ReactComponent as Enter16 } from "./16/enter.svg";
import { ReactComponent as ClearSolid16 } from "./16/clear-solid.svg";
import { ReactComponent as ClearSolid24 } from "./24/clear-solid.svg";
import { ReactComponent as Enter24 } from "./24/enter.svg";
import { ReactComponent as ErrorSolid16 } from "./16/error-solid.svg";
import { ReactComponent as ErrorSolid24 } from "./24/error-solid.svg";
import { ReactComponent as HomeSolid24 } from "./24/home-solid.svg";
import { ReactComponent as Media24 } from "./24/media.svg";
import { ReactComponent as Note24 } from "./24/note.svg";
import { ReactComponent as Pin24 } from "./24/pin.svg";
import { ReactComponent as RenameSolid24 } from "./24/rename-solid.svg";
import { ReactComponent as Tooltip24 } from "./24/tooltip.svg";
import { ReactComponent as Trash24 } from "./24/trash.svg";
import { ReactComponent as Global24 } from "./24/global.svg";
import { ReactComponent as VisionPro24 } from "./24/visionrpro.svg";
import { ReactComponent as Prototype24 } from "./24/prototype.svg";
import protopieSolid24 from "./24/protopie-solid.png";

type SvgIconComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;

// Keep this registry limited to production consumers. The complete approved
// set stays in icons.json and a new consumer adds its exact asset here.
export const svgIconRegistry = {
  "measurement-cursor-28": MeasurementCursor28,
  "measurement-start-14": MeasurementStart14,
  "toolbar-move-28": ToolbarMove28,
  "toolbar-measure-28": ToolbarMeasure28,
  "toolbar-rotation-24": ToolbarRotation24,
  "global-24": Global24,
  "visionrpro-24": VisionPro24,
  "add-24": Add24,
  "prototype-24": Prototype24,
  "enter-24": Enter24,
  "enter-16": Enter16,
  "clear-solid-24": ClearSolid24,
  "clear-solid-16": ClearSolid16,
  "3d-object-16": ThreeDObject16,
  "add-16": Add16,
  "box-dimensions-16": BoxDimensions16,
  "check-16": Check16,
  "linear-16": Linear16,
  "close-16": Close16,
  "fold-16": Fold16,
  "info-16": Info16,
  "question-16": Question16,
  "left-arrow-16": LeftArrow16,
  "navi-left-arrow-24": NaviLeftArrow24,
  "lock-16": Lock16,
  "checkbox-empty-24": CheckboxEmpty24,
  "checkbox-solid-24": CheckboxSolid24,
  "close-24": Close24,
  "reset-24": Reset24,
  "search-24": Search24,
  "search-16": Search16,
  "complete-solid-24": CompleteSolid24,
  "error-solid-16": ErrorSolid16,
  "error-solid-24": ErrorSolid24,
  "home-solid-24": HomeSolid24,
  "media-24": Media24,
  "note-24": Note24,
  "pin-24": Pin24,
  "rename-solid-24": RenameSolid24,
  "tooltip-24": Tooltip24,
  "trash-24": Trash24,
} as const satisfies Record<string, SvgIconComponent>;

export const rasterIconRegistry = {
  "protopie-solid-24": protopieSolid24,
} as const;

export type SvgIconName = keyof typeof svgIconRegistry;
export type RasterIconName = keyof typeof rasterIconRegistry;
export type IconName = SvgIconName | RasterIconName;

export const iconNames: readonly IconName[] = [
  ...Object.keys(svgIconRegistry),
  ...Object.keys(rasterIconRegistry),
] as IconName[];
